import { createFileRoute, redirect } from '@tanstack/react-router'
import { getV1MeRetrieveQueryOptions } from '@/api/client'

export const Route = createFileRoute('/_panel/')({
  // Role-aware landing: /szkoly bounces teachers straight back here (its
  // beforeLoad redirects role==='teacher' to '/'), which used to loop — a
  // freshly activated teacher (feature 015, TR-700 step 10) must land on a
  // page they can actually see.
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(getV1MeRetrieveQueryOptions())
    const isTeacher = me.status === 200 && me.data.role === 'teacher'
    throw redirect({ to: isTeacher ? '/moje-szkoly' : '/szkoly' })
  },
})
